import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as CryptoJS from "crypto-js";
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ChangePasswordComponent implements OnInit {

  lbl_go_Back: string = "back_";
  lbl_change_password: string = "change_password_";
  lbl_update: string = "update_";
  lbl_current: string = "current_";
  lbl_password: string = "password_";
  lbl_new: string = "new_";
  lbl_confirm:string="confirm_";
  lbl_entry:string="entry_";
  lbl_does_not_match:string="does_not_match_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_change: string = "change_";



  currentUser: any;
  token: string;

  security: SecurityDocument;

  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  validInformation: boolean = false;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;

        });
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
    this.cleanInputs();
  }

  confirmUpdatePassword() {
    this.confirmationService.confirm({
      message: '¿ ' +this.lbl_are_you_sure +' '+ this.lbl_change +' '+ this.lbl_password+' ?',
      header: this.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.updatePassword();

      }
    });
  }

  updatePassword() {
    let currentPassword = CryptoJS.MD5(this.currentPassword).toString();
    if (this.isValidInformation()) {
      const body = {
        userName: this.security.userId,
        password: CryptoJS.MD5(this.currentPassword).toString(),
        newPassword: CryptoJS.MD5(this.newPassword).toString(),
      }
      this.apiService.updatePassword(body).then(
        data => {
          //this.security = data;
          this.messageService.add({ severity: 'success', summary: 'Actualizar contraseña', detail: "Se actualizo contraseña correctamente", life: 3000 });
          this.cleanInputs();
        }).catch(error => {
          console.error(error);
          this.messageService.add({ severity: 'error', summary: 'Actualizar contraseña', detail: "Contraseña incorrecta", life: 3000 });
        });

    } else {
      console.error("Informacion incorrecta");
      this.messageService.add({ severity: 'error', summary: 'Actualizar contraseña', detail: 'Favor de poner información correctamente', life: 3000 });
    }
  }



  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser != null && this.currentUser.tokenProfile ? this.currentUser.tokenProfile : this.token }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels()
        });
    }


  }

  cleanInputs() {
    this.currentPassword = "";
    this.newPassword = "";
    this.confirmNewPassword = "";
  }

  isValidInformation() {
    if (this.confirmNewPassword.length > 0 && (this.newPassword === this.confirmNewPassword)) {
      this.validInformation = true;
      return true;
    } else {
      this.validInformation = false;
      return false;
    }
  }
  goBack() {
    window.close();
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_change_password, this.lbl_update,this.lbl_current,this.lbl_new,this.lbl_password,this.lbl_confirm,this.lbl_entry,this.lbl_does_not_match, this.lbl_are_you_sure, this.lbl_change]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_change_password = map.get(this.lbl_change_password);
        this.lbl_update = map.get(this.lbl_update);
        this.lbl_current = map.get(this.lbl_current);
        this.lbl_new = map.get(this.lbl_new);
        this.lbl_password = map.get(this.lbl_password);
        this.lbl_confirm= map.get(this.lbl_confirm);
        this.lbl_entry= map.get(this.lbl_entry);
        this.lbl_does_not_match= map.get(this.lbl_does_not_match);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_change = map.get(map.get(this.lbl_change));
       
      });
  }
}
